import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import eyebox from "../../Utils/Images/eyebox.png";
import userbox from "../../Utils/Images/Userbox.png";
import deletebox from "../../Utils/Images/deletebox.png";
import productimg from "../../Utils/Images/golam_logo 1.png";
import { Link } from "react-router-dom";
const UserDetailsTable = ({ UserDetailsData }) => {
  return (
    <>
      <Box>
        {/* heading */}
        <Box
          sx={{
            boxShadow: "none",
            outline: "none",
            mb: "10px",
            border: "none",
            mt: "10px",
            boxSizing: "border-box",
          }}
        >
          <Grid container>
            {/* first column */}
            <Grid item xs={0.5} md={0.5}>
              <Paper
                sx={{
                  borderRadius: "0px",
                  border: "1px solid #EFEFEF",
                  boxShadow: "none",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "inter",
                    fontWeight: "400",
                    fontSize: "16px",

                    opacity: "45%",
                    color: "#252525",
                  }}
                >
                  #
                </Typography>
              </Paper>
            </Grid>
            {/* Second Column */}
            <Grid item xs={2.5} md={2.5}>
              <Paper
                sx={{
                  borderRadius: "0px",
                  border: "1px solid #EFEFEF",
                  boxShadow: "none",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "inter",
                    fontWeight: "400",
                    fontSize: "16px",

                    opacity: "45%",
                    color: "#252525",
                  }}
                >
                  Photo
                </Typography>
              </Paper>
            </Grid>
            {/* Third Column */}
            <Grid item xs={4.5} md={4.5}>
              <Paper
                sx={{
                  borderRadius: "0px",
                  border: "1px solid #EFEFEF",
                  boxShadow: "none",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "inter",
                    fontWeight: "400",
                    fontSize: "16px",

                    opacity: "45%",
                    color: "#252525",
                  }}
                >
                  Product Name
                </Typography>
              </Paper>
            </Grid>
            {/* Fourth Column */}
            <Grid item xs={2.5} md={2.5}>
              <Paper
                sx={{
                  borderRadius: "0px",
                  border: "1px solid #EFEFEF",
                  boxShadow: "none",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "inter",
                    fontWeight: "400",
                    fontSize: "16px",

                    opacity: "45%",
                    color: "#252525",
                  }}
                >
                  Product Price
                </Typography>
              </Paper>
            </Grid>
            {/* fifth Column */}

            <Grid item xs={2} md={2}>
              <Paper
                sx={{
                  borderRadius: "0px",
                  border: "1px solid #EFEFEF",
                  boxShadow: "none",
                  height: "50px",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  justifyContent: "center",
                  // bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "inter",
                    fontWeight: "400",
                    fontSize: "16px",

                    opacity: "45%",
                    color: "#252525",
                  }}
                >
                  Action
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Box>
        <Box
          sx={{
            border: "1px solid #DDDDDD",
            height: "100%",
            overflow: "auto",
            mt: "10px",
            borderTop: "0.5px solid #DDDDDD",
            maxHeight: "75vh",
          }}
        >
          <Box>
            <Grid container>
              {/* first column */}
              <Grid item xs={0.5} md={0.5}>
                {UserDetailsData.map((item, i) => (
                  <Paper
                    sx={{
                      border: "1px 1px 1px 0 solid #DDDDDD",
                      borderRadius: "0px",
                      height: "70px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                    key={i}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                      }}
                    >
                      {i + 1}
                    </Typography>
                  </Paper>
                ))}
              </Grid>
              {/* Second Column */}
              <Grid item xs={2.5} md={2.5}>
                {UserDetailsData.map((item, i) => (
                  <Paper
                    sx={{
                      border: "1px 1px 1px 0 solid #DDDDDD",
                      borderRadius: "0px",
                      height: "70px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                    }}
                    key={i}
                  >
                    <Box sx={{ width: "40px", height: "40px" }}>
                      <img
                        width={"100%"}
                        height={"100%"}
                        src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${item?.product_images?.product_image}`}
                        alt="preview"
                      />
                    </Box>
                  </Paper>
                ))}
              </Grid>
              {/* Third Column */}
              <Grid item xs={4.5} md={4.5}>
                {UserDetailsData.map((item, i) => (
                  <Paper
                    sx={{
                      border: "1px 1px 1px 0 solid #DDDDDD",
                      borderRadius: "0px",
                      height: "70px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                    }}
                    key={i}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: "90%",
                        "&:hover": {
                          overflow: "visible",
                        },
                      }}
                    >
                      {item.product_name}
                    </Typography>
                  </Paper>
                ))}
              </Grid>
              {/* Fourth Column */}
              <Grid item xs={2.5} md={2.5}>
                {UserDetailsData.map((item, i) => (
                  <Paper
                    key={i}
                    sx={{
                      border: "1px 1px 1px 0 solid #DDDDDD",
                      borderRadius: "0px",
                      height: "70px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: "90%",
                        "&:hover": {
                          overflow: "visible",
                        },
                      }}
                    >
                      {item.discount_price}
                    </Typography>
                  </Paper>
                ))}
              </Grid>
              {/* fifth Column */}

              <Grid item xs={2} md={2}>
                {UserDetailsData.map((e, i) => (
                  <Paper
                    sx={{
                      border: "1px 1px 1px 0 solid #DDDDDD",
                      borderRadius: "0px",
                      height: "70px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                    }}
                  >
                    <Box
                      sx={{
                        p: "5px",
                        display: "Flex",
                        width: "100%",
                        justifyContent: "center",
                        gap: "5px",
                      }}
                    >
                      <Box sx={{ width: "25%", cursor: "pointer" }}>
                        <Link to={`/productdetails/${e.id}`}>
                          <img width={"100%"} src={eyebox} alt="" />
                        </Link>
                      </Box>
                    </Box>
                  </Paper>
                ))}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default UserDetailsTable;
